import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getTargetSystem = async () => {
  const { data } = await axios.get(
    `${api_base_url}/Configuration/TargetSystem`
  );
  //const { data } = await axios.get("https://localhost:44399/api/TargetSyStem");

  return data;
};

//Insert New TargetSyStem
export const addTargetSystem = async (newTargetSyStem) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/TargetSyStem`,
      newTargetSyStem[0]
  );
  return data;
};
// Update TargetSyStem
export const updateTargetSystem = async (updatedTargetSystemData) => {
  await axios.put(
      `${api_base_url}/Configuration/TargetSystem${updatedTargetSystemData[0].targetSystemId}`,
      updatedTargetSystemData[0]
  );
};
//Delete TargetSyStem by Id
export const deleteTargetSystem = async (TargetSyStemId) => {
  await axios.delete(
    `${api_base_url}/Configuration/TargetSyStem${TargetSyStemId}`,
    {
      data: TargetSyStemId,
    }
  );
};

//
//Delete Fee Type
export const deletePolicyType = async (PolicyTypeId) => {
  await axios.delete(
    `${api_base_url}/Configuration/PolicyType${PolicyTypeId}`,
    {
      data: PolicyTypeId,
    }
  );
};

export const getPolicyType = async () => {
  const { data } = await axios.get(`${api_base_url}/Configuration/PolicyTypes`);
  return data;
};

export const getLicenseType = async () => {
  const { data } = await axios.get(`${api_base_url}/Configuration/LicenseType`);

  return data;
};

// Update PolicyType

export const updatePolicyType = async (updatedPolicyTypeData) => {
  const data = await axios.put(
    `${api_base_url}/Configuration/PolicyType${updatedPolicyTypeData.policyTypeID}`,
    updatedPolicyTypeData
  );
  return data;
};

//Insert New Policy Type
export const addPolicyType = async (newPolicyType) => {
  const { data } = await axios.post(
    `${api_base_url}/Configuration/PolicyType`,
    newPolicyType
  );
  return data;
};
